import {Authorization} from 'domain/usecases';
import {translations} from 'presentation/translations-new';
import IconNamesType from 'presentation/icons/IconNamesType';
import {getAttendanceProtocol} from './protocolFields';

const {authorizationCard} = translations['pt-br'].privateFlow.requestAuthorizations;

export const getStatusList = (authorization: Authorization) => {
	const attendanceProtocol = getAttendanceProtocol(authorization);

	return [
		{
			iconName: 'event-filled' as IconNamesType,
			primaryText: authorization.dtAutorizacao ? authorization.dtAutorizacao : '-',
			secondaryText: authorizationCard.requestedAt,
			flexDirection: 'column-reverse',
		},
		{
			iconName: 'assignment-filled' as IconNamesType,
			primaryText: attendanceProtocol || '-',
			secondaryText: authorizationCard.protocol,
			flexDirection: 'column-reverse',
		},
	];
};
